<template>
  <div>
    <div class="wechat-overlay">
      <img src="@/assets/icons/android_overlay.svg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wechat-overlay {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.wechat-overlay img {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 230px;
}
</style>



// WEBPACK FOOTER //
// src/components/WechatOverlay.vue